import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {RoutesEnum} from '../../core/services/navigation/routes.enum';
import {HomeComponent} from './home.component';
import {AuthGuardService} from '../../core/services/security/auth-guard.service';

const routes: Routes = [
  {
    path: RoutesEnum.HOME,
    component: HomeComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {
}
